/**
 * @file index.tsx
 *
 * @fileoverview Shows the gallery widget title when in view mode.
 */
import { FormattedMessage } from 'react-intl';

export const OrganizationVideoGalleryWidgetViewTitle = () => (
  <FormattedMessage
    id="organization_video_gallery_label"
    defaultMessage="Video gallery"
  />
);

export default OrganizationVideoGalleryWidgetViewTitle;
